module.exports = __webpack_public_path__ + "MetagamingPigeon.jpg?384bee064734d87e10619fe5e9915a03";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/MetagamingPigeon.jpg
// module id = 528
// module chunks = 0